function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M14.375 5.935l4.186 4.185h-3.152v7.388H13.34V10.12H10.19l4.186-4.185zm7.337 14.725h3.152l-4.185 4.186-4.186-4.186h3.152v-7.388h2.067v7.388z",
  fill: "#4A4A4A",
  fillRule: "evenodd"
})));